import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { UsersService } from 'src/app/modules/users/services/users.service';
import Swal from 'sweetalert2';

import { MustMatch } from '../../../../shared/_helpers/must-match-validation'

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit {

  public user_details = this.authenticationService.getUserDetails();

  public userName = this.authenticationService.getUserName();

  public userForm:FormGroup;

  constructor(private fb:FormBuilder,
              private authenticationService: AuthenticationService,
              private userService: UsersService) { }

  ngOnInit(): void {
      this.createForm();
  }

  createForm(){
    this.userForm = this.fb.group({
      'user_id': [this.user_details.user_id],
      'name': [this.userName,[Validators.required]],
      'new_password': [''],
      'confirm_new_password': [''],
    },{
       validators:MustMatch('new_password','confirm_new_password')
    });
  }

  get f(){ return this.userForm.controls}

  userFormSubmit(){

    if(this.userForm.value.new_password != ""){
      this.userForm.controls["new_password"].setValidators([Validators.required,Validators.minLength(8)]);
      this.userForm.controls['new_password'].updateValueAndValidity()
    }

    if(!this.userForm.valid){
      return;
    }

    this.userService.changeUserData(this.userForm.value).subscribe(
      (res:any) => {
        if(res.status == 'success'){
          this.authenticationService.setUserName(this.userForm.value.name);
        }

        Swal.fire({
          icon: res.status,
          text: res.message,
        });
        
      },
      (err)=> {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong! Please try again later.',
        });
      }
    )
  }


}
